import { Button, Popup, Table } from "semantic-ui-react";

import { formatDateForMatchRow } from "./CarrierCapacityShipmentMatchTableRow";
import { MyCarrierMatchesCapacityInfoDto } from "models/dto/MyCarrierMatchesCapacityInfoDto";

import styles from "./CarrierCapacityShipmentMatchTable.module.scss";

export const shipmentMatchColSpan = 10;

const typeToAbbreviationMap = {
  Capacity: "C",
  "Preferred Lane": "PL",
};

type CarrierCapacityShipmentMatchCapacityTableRowProps = {
  capacity: Omit<MyCarrierMatchesCapacityInfoDto, "rate" | "shipmentIds">;
  message?: string;
};

const CarrierCapacityShipmentMatchCapacityTableRow = (
  props: CarrierCapacityShipmentMatchCapacityTableRowProps
) => {
  const formattedCapacityRoute = `${props.capacity.origin ?? "Any Origin"} → ${props.capacity.destination ?? "Any Destination"}`;

  return (
    <Table.Row>
      <Table.Cell
        colSpan={shipmentMatchColSpan}
        className={styles.capacityCell}
      >
        <Popup
          offset={[-10, 0]}
          wide="very"
          trigger={
            <Button type="button" icon circular size="mini" color="blue">
              {typeToAbbreviationMap[props.capacity.capacityType]}
            </Button>
          }
        >
          <Popup.Header>{props.capacity.capacityType} Information</Popup.Header>
          <Popup.Content>
            {props.capacity.capacityType === "Capacity" &&
            props.capacity.date ? (
              <div>
                {formatDateForMatchRow({
                  dateString: props.capacity.date,
                  timeZone: "UTC",
                  includeTime: false,
                })}
              </div>
            ) : null}
            <div>{props.capacity.equipmentType}</div>
            <div>{formattedCapacityRoute}</div>
            {props.capacity.note ? <div>{props.capacity.note}</div> : null}
          </Popup.Content>
        </Popup>
        {formattedCapacityRoute}
        {props.message ? ` - ${props.message}` : null}
      </Table.Cell>
    </Table.Row>
  );
};

export default CarrierCapacityShipmentMatchCapacityTableRow;
